import { useEffect } from 'react';
import { BodyClass } from '@plone/volto/helpers';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUnicoToken } from '../../actions';
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
import { getCookieOptions } from '@plone/volto/helpers';
import { toast } from 'react-toastify';
import { Toast } from '@plone/volto/components';


const messages = defineMessages({
  login_failed: {
    id: 'login_failed',
    defaultMessage: 'Login Failed',
  },
  registration_not_found: {
    id: 'registration_not_found',
    defaultMessage: 'User registration not found for content editing.',
  },
  code_not_available: {
    id: 'code_not_available',
    defaultMessage: 'Validation code for obtaining Token is not available.',
  },
  conf_level_1: {
    id: 'conf_level_1',
    defaultMessage: 'The user must have a login with a Bronze trust level.',
  },
  conf_level_2: {
    id: 'conf_level_2',
    defaultMessage: 'The user must have a login with a Silver trust level.',
  },
  conf_level_3: {
    id: 'conf_level_3',
    defaultMessage: 'The user must have a login with a Gold trust level.',
  },
  no_trust_level: {
    id: 'no_trust_level',
    defaultMessage: 'It was not possible to retrieve the user`s trust level.',
  },
  default_login_error: {
    id: 'default_login_error',
    defaultMessage: 'Failed to obtain data from acesso.gov.br.',
  }
});

/**
 * LoginUnicoToken.
 * @function Token
 * @returns {string} loginunico_token.
 */
const Token = (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  // const history = useHistory();
  // parametros enviados de volta pela chamada
  // realizada pelo acesso.gov.br
  const search = props.location.search;
  let params = new URLSearchParams(search);
  let rcode = params.get('code');
  let rstate = params.get('state');
  // chamada ao @loginunico-token
  useEffect(() => {
    dispatch(
      loginUnicoToken(
        rcode,
        rstate,
      ),
    );
  }, [dispatch, rcode, rstate]);
  // JWT Token
  let token_value = useSelector((state) => state.loginunico_token.userSession.token) || null;
  // expiracao do cookie conforme configuracao do control panel
  let expires_date = useSelector((state) => state.loginunico_token.expires_gmt) || null;
  if ( expires_date ){
    expires_date = new Date(expires_date);
  }
  // redirect after login
  let redirect_after_login = useSelector((state) => state.loginunico_token.redirect_after_login) || '/';
  // error
  let error =  useSelector((state) => state.loginunico_token.error) || null;
  let error_msg = null;
  if ( error ){
    if ( 'response' in error ){
      if ( 'text' in error.response ){
        try {
          const data = JSON.parse(error.response.text);
          error_msg = data.error.message;
        }
        catch(err){
          console.log(error);
          error_msg = 'login_failed';
        }
      }
    }
  }
  if (token_value) {
    if (! expires_date){
      // expiracao cookie igual a do token
      // /Plone/acl_users/jwt_auth/manage_config
      // * 1000 transforma em milisegundos
      expires_date = new Date(jwtDecode(token_value).exp * 1000);
    }
    // cookies
    const cookies = new Cookies();
    // remove caso exista
    cookies.remove('auth_token', { path: '/' });
    // cria novo cookie
    // secure = true se https por padrao do helper
    cookies.set(
      'auth_token',
      token_value,
      getCookieOptions({
        expires: expires_date,
      }),
    );
    // redireciona para raiz do site
    let actual_url = window.location.href;
    let base_url = actual_url.substring(0, actual_url.indexOf('loginunico_token'));
    // redirecionamento padrao raiz do site
    let redirect_uri = base_url;
    if ( redirect_after_login ) {
      if ( redirect_after_login.at(0) == '/' ) {
        redirect_uri = base_url.slice(0, -1);
      }
      redirect_uri = redirect_uri + redirect_after_login;
    }
    window.location.href = redirect_uri;
  }
  else if ( error_msg ){
    // popup com mensagem de erro
    let msg_id = 'default_login_error';
    if (error_msg in messages) {
      msg_id = error_msg;
    }
    toast.error(
      <Toast
        error
        title={intl.formatMessage(messages.login_failed)}
        content={intl.formatMessage(messages[msg_id])}
      />,
      { autoClose: true, toastId: 'loginFailed' },
    );
  }
  return (
    <Container className="view-wrapper">
      <BodyClass className="page-loginunico-token" />
      <h1>
        <FormattedMessage
          id="login_with_govbr"
          defaultMessage="Login with gov.br"
        />
      </h1>
      <Link to="/">
        <FormattedMessage
          id="go_to_home"
          defaultMessage="Go to home"
        />
      </Link>
    </Container>
  );
};

export default (Token);